module.exports = __webpack_public_path__ + "img/vibe-nation.bbf8aa17.png";